import { initContract } from '@ts-rest/core';
import { publicBrevoContract } from './brevo.public.contract';

const c = initContract();

export const brevoContract = c.router(
  {
    public: publicBrevoContract,
  },
  {
    pathPrefix: '/brevo',
    strictStatusCodes: true,
  },
);

export * from './brevo.public.contract';
